import * as config from "../../constants/config";

/**
 * @class Server
 */
export default class Server {
    /**
     * @param {string} ip
     * @param {number} port
     * @param {string} version
     * @param {string} name
     */
    constructor(ip, port, version, name) {
        this._id = null;
        this._ip = ip;
        this._port = port;
        this._version = version;
        this._name = name;
        this._lastActivity = null;
        this._active = null;
        this._note = null;
        this._uuid = null;
        this._computerId = null;
        this._multicast = null;
        this._enabled = null;

        if (typeof this._ip !== "string") {
            throw new Error("Invalid datatype of ip");
        }
    }

    /**
     * @return {number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {string}
     */
    get ip() {
        return this._ip;
    }

    /**
     * @param value
     */
    set ip(value) {
        this._ip = value;
    }

    /**
     * @return {Number}
     */
    get port() {
        return this._port;
    }

    /**
     * @param value
     */
    set port(value) {
        this._port = value;
    }

    /**
     * @return {string}
     */
    get version() {
        return this._version;
    }

    /**
     * @param value
     */
    set version(value) {
        this._version = value;
    }

    /**
     * @return {string}
     */
    get name() {
        return this._name;
    }

    /**
     * @param value
     */
    set name(value) {
        this._name = value;
    }

    /**
     * @return {string}
     */
    get lastActivity() {
        return this._lastActivity;
    }

    /**
     * @param lastActivity
     */
    set lastActivity(lastActivity) {
        this._lastActivity = lastActivity;
    }

    /**
     * @return {boolean}
     */
    get active() {
        return this._active;
    }

    /**
     * @param active
     */
    set active(active) {
        this._active = active;
    }

    /**
     * @return {string}
     */
    get note() {
        return this._note;
    }

    /**
     * @param note
     */
    set note(note) {
        this._note = note;
    }

    /**
     * @return {string}
     */
    get uuid() {
        return this._uuid;
    }

    /**
     * @param uuid
     */
    set uuid(uuid) {
        this._uuid = uuid;
    }

    /**
     * @return {string}
     */
    get computerId() {
        return this._computerId;
    }

    /**
     * @param computerId
     */
    set computerId(computerId) {
        this._computerId = computerId;
    }

    /**
     * @return {boolean}
     */
    get multicast() {
        return this._multicast;
    }

    /**
     * @param multicast
     */
    set multicast(multicast) {
        this._multicast = multicast;
    }

    /**
     * @return {boolean}
     */
    get enabled() {
        return this._enabled;
    }

    /**
     * @param multicast
     */
    set enabled(enabled) {
        this._enabled = enabled;
    }

    /**
     * @return {Object}
     */
    clone() {
        let clone = new Server(this._ip, this._port, this._version, this._name);

        clone.id = this._id;
        clone.lastActivity = this._lastActivity;
        clone.active = this._active;
        clone.note = this._note;
        clone.uuid = this._uuid;
        clone.computerId = this._computerId;
        clone.multicast = this._multicast;
        clone.enabled = this._enabled;

        return clone;
    }

    /**
     * @return {Object}
     */
    updateServerData(uuid, version, name) {
        let server = this.clone();
        server.version = version;
        server.name = name;
        server.uuid = uuid;

        return server;
    }

    /**
     * @return {Object}
     */
    updateMulticast(multicast) {
        let server = this.clone();
        server.multicast = multicast;

        return server;
    }

    /**
     * @return {Object}
     */
    updateComputerId(computerId) {
        let server = this.clone();
        server.computerId = computerId;

        return server;
    }

    /**
     * @return {String}
     */
    toString() {
        return "Server (" + this._ip + ")";
    }

    /**
     * Returns websocket url
     * @return {string}
     */
    getWebSocketUrl() {
        return config.WEBSOCKET_PROTOCOL + this._ip + ":" + this._port;
    }

    /**
     * Returns unique key for server in subnet.
     * @return {string}
     */
    getKey() {
        let ipNumbers = this._ip.split(".");

        if (ipNumbers.length !== 4) {
            return this._name;
        }

        return this._name + "-" + ipNumbers[3];
    }
}
